import { Fragment } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { CarrierProvider, useCarrier } from '../../contexts/CarrierContext';
import { useAuth } from '../../contexts/AuthContext';
import CarrierChooser from './CarrierChooser';
import CarrierSwitcher from './CarrierSwitcher';
import './carrier.css';
import '../../styles/AdminPage.css';

// Only carrier-owned subtrees use this gate. Unscoped forceMount tabs stay alive.
export function CarrierScope({ children }) {
  const { inShell, carrier, readyId } = useCarrier();
  if (!inShell) return children;
  if (!carrier || readyId !== carrier.id) return null;
  return <Fragment key={carrier.id}>{children}</Fragment>;
}

function ShellBody({ children }) {
  const { carrier, loading, error } = useCarrier();
  const { signOut } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  if (!carrier || loading || error) return <div className="admin-root" dir="rtl">
    <div className="admin-bar">
      <span className="admin-bar-brand">سامانهٔ FTTX</span>
      <CarrierSwitcher />
      <button type="button" className="admin-bar-exit" onClick={async () => {
        await signOut(); navigate('/login', { replace: true });
      }}>خروج</button>
    </div>
    <div className="admin-body"><CarrierChooser /></div>
  </div>;
  if (location.pathname.startsWith('/admin')) return children;
  return <CarrierScope>{children}</CarrierScope>;
}

export default function CarrierShell({ children }) {
  return <CarrierProvider><ShellBody>{children}</ShellBody></CarrierProvider>;
}
